import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { EventModel } from '../models/events.model';
import { IEventReminder } from '../repositories/IEvents.repository';

export interface IEventsService<T1> {
  getEvents(): Observable<T1[]>;
  createEvent(payload: EventModel): Observable<T1>;
  updateEvent(payload: EventModel): Observable<T1>;
  deleteEvent(payload: number): Observable<boolean>;
}

export interface ILocalNotificationsService {
  setReminder(reminder: IEventReminder);

  removeReminder(id: number);

  updateReminder(reminder: IEventReminder);

  checkIdScheduled(id: number);

  init();

  stop();
}

export const EVENTS_SERVICE = new InjectionToken<IEventsService<EventModel>>(
  'eventsService'
);

export const LOCAL_NOTIFICATIONS_SERVICE = new InjectionToken(
  'localNotificationsService'
);
